export async function urlToFile(url: string, filename: string): Promise<File> {
  // 1. Fetch로 이미지 데이터를 가져옴
  const response = await fetch(url)
  // 2. Blob으로 변환
  const blob = await response.blob()
  // 3. File 객체 생성 (세 번째 인자는 옵션으로, lastModified 등을 지정할 수 있음)
  return new File([blob], filename, { type: blob.type })
}
